export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
  color: string;
}

export const categories: Category[] = [
  {
    id: 'entertainment',
    name: '娱乐',
    icon: 'ri-movie-2-line',
    description: '明星动态、剧集花絮、红毯现场与综艺高能名场面，第一时间追娱乐热点。',
    color: 'accent',
  },
  {
    id: 'life',
    name: '生活',
    icon: 'ri-plant-line',
    description: '美食、家居、旅行与日常记录，把平凡生活的每个小确幸拍给你看。',
    color: 'secondary',
  },
  {
    id: 'funny',
    name: '搞笑',
    icon: 'ri-emotion-laugh-line',
    description: '萌宠、整蛊、沙雕动画与名场面合集，随时一键开启快乐模式。',
    color: 'primary',
  },
  {
    id: 'music',
    name: '音乐',
    icon: 'ri-music-2-line',
    description: '街头翻唱、民谣现场与电音派对，用声音记录每一次心动瞬间。',
    color: 'accent',
  },
  {
    id: 'sports',
    name: '运动',
    icon: 'ri-basketball-line',
    description: '马拉松、街头篮球与极限运动集锦，感受热血与汗水的力量。',
    color: 'secondary',
  },
  {
    id: 'gaming',
    name: '游戏',
    icon: 'ri-gamepad-line',
    description: '新版本攻略、电竞翻盘与建筑大神作品，属于玩家的高光时刻。',
    color: 'primary',
  },
];